import { AutoAwesome } from "@mui/icons-material";
import { alpha, Box, Stack, Typography } from "@mui/material";
import { ApiChartAttribute } from "@incendium/api";
import {
  DASHBOARD_REPORTS,
  DashboardReportId,
} from "features/dashboard/constants/dashboardReports";

interface IPlaceholderReportTabProps {
  attributes: ApiChartAttribute[];
  reportId: DashboardReportId;
}

function PlaceholderReportTab({ reportId }: IPlaceholderReportTabProps) {
  const report = DASHBOARD_REPORTS.find((item) => item.id === reportId);

  return (
    <Box
      sx={(theme) => ({
        flex: 1,
        minHeight: 280,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 2,
        border: `1px dashed ${alpha(theme.palette.primary.main, 0.35)}`,
        bgcolor: alpha(theme.palette.primary.main, 0.04),
        p: 4,
      })}
    >
      <Stack
        spacing={1.5}
        alignItems="center"
        textAlign="center"
        maxWidth={460}
      >
        <AutoAwesome sx={{ color: "primary.main", fontSize: 28 }} />
        <Typography variant="h6" fontWeight={700}>
          {report?.label || "Report"} coming soon
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {report?.description ||
            "This report is on the roadmap and will appear here once it is ready."}
        </Typography>
        {report?.sourceReport && (
          <Typography variant="caption" color="text.disabled">
            Will reuse charts from {report.sourceReport}
          </Typography>
        )}
        {report?.borrows && report.borrows.length > 0 && (
          <Stack spacing={0.5} alignItems="center" sx={{ mt: 0.5 }}>
            {report.borrows.map((item) => (
              <Typography
                key={item}
                variant="caption"
                color="text.secondary"
                sx={{ opacity: 0.85 }}
              >
                · {item}
              </Typography>
            ))}
          </Stack>
        )}
      </Stack>
    </Box>
  );
}

export default PlaceholderReportTab;
